:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._progressBar_jv8zi_7 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center; }
  ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13 {
    margin: 0 12px;
    width: 15px;
    height: 15px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center; }
    ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13 ._circle_jv8zi_21 {
      background: #d6e6fe;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      margin: 3px; }
    ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepVisited_jv8zi_27 ._circle_jv8zi_21 {
      background: #116dff; }
    ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepVisited_jv8zi_27:hover ._circle_jv8zi_21 {
      background: #5999ff; }
    ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepVisited_jv8zi_27:not(._progressBarStepCurrent_jv8zi_31) {
      cursor: pointer; }
    ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepCurrent_jv8zi_31 ._circle_jv8zi_21 {
      background: #116dff; }
      ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepCurrent_jv8zi_31 ._circle_jv8zi_21:after {
        content: '';
        display: block;
        position: absolute;
        border-radius: 50%;
        border: 1px solid #116dff;
        width: 13px;
        height: 13px;
        left: 0;
        top: 0; }
        ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepCurrent_jv8zi_31 ._circle_jv8zi_21:after:hover {
          background: #5999ff; }
      ._progressBar_jv8zi_7 ._progressBarStep_jv8zi_13._progressBarStepCurrent_jv8zi_31 ._circle_jv8zi_21:hover {
        background: #5999ff; }
